<template>
  <iColumn width="fill" height="hug" gap="none">
    <ChannelList
      :edit-mode="editMode"
      :entity-id="entityId"
      visibility-type="exclusive"
    />
  </iColumn>
</template>

<script>
import ChannelList from "%/components/community/chatrooms/slack-style/ChannelList.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";

export default {
  name: "ListOfExclusiveChannels",
  components: {
    ChannelList,
  },
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    displayName: "List Of Exclusive Channels",
    displayIcon: "list",
    elementGroup: "chatRoomElements",
    elementType: "element",
  },
  optionBundles: [
    LayoutWidthHeightOptions,
  ],
};
</script>

<style lang="scss" scoped>
</style>
